import { LayerItem } from "../../services/types";
import { formatValueBase, parseMarkdown } from "../../utils/helpers";

interface StoryCardProps {
    width: string;
    layerItem: LayerItem;
    isActive: boolean;
    setActiveCardId: (id: number) => void;
};

const StoryCard = ({ width, layerItem, isActive, setActiveCardId }: StoryCardProps) => {
    // Destructure metric properties
    const { description, name, value, category, id, latitude, longitude, attributes } = layerItem;

    // Extract image_url from attributes
    const imageUrl = attributes.find((attr: any) => attr.name === "image_url")?.value;

    const portOrigin = '*';

    // Handle hover event
    const handleHover = () => {
        setActiveCardId(id); // Update the last active card

        // Send message to the parent window
        window.parent.postMessage(
            {
                message: "showProgramPoint",
                data: {
                    id,
                    latitude,
                    longitude,
                },
            },
            portOrigin
        );
        console.log("Program point message sent:", { id, latitude, longitude });
    };

    return (
        <div
        className={`relative border rounded-md bg-white p-4 shadow-sm ${width} flex flex-col items-start transition-all duration-150 
            ${isActive ? 'border-4 border-port-green ring-2 ring-port-green shadow-lg' : ''} 
            hover:shadow-lg hover:border-4 hover:border-port-green hover:ring-2 hover:ring-port-green`}
        onMouseEnter={handleHover}
        >
            {imageUrl && (
                <img
                    src={imageUrl}
                    alt={`${name} Image`}
                    className="w-32 max-h-32 object-cover"
                />
            )}  
            {/* Name */}
            <h2 className="text-sm font-bold text-port-text mb-2 border-b">{name}</h2>
            {/* Category */}
            <p className="text-[9px] text-port-green mb-2">{category?.toUpperCase()}</p>
            {/* Description with HTML */}
            <div
                className="text-[9px] text-port-text mb-4"
                dangerouslySetInnerHTML={{ __html: parseMarkdown(description) }}
            />

            {/* Fund Amount */}
            <p className="text-[11px] text-port-text">
                <strong>Fund Amount:</strong> {formatValueBase(value, 'currency')}
            </p>
        </div>
    );
};

export default StoryCard;
